import React, { Fragment, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import moment from "moment";
import { employeeColumns } from "../../Data/Users/Employee";
import { Spinner } from "../../AbstractElements";
import CommonToolTip from "../Common/Component/CommonToolTip";
import HardResetPassword from "./HardResetPassword";
import CustomizerContext from "../../_helper/Customizer";

const ExternalUserTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    loader,
    setEditId,
    toggleCreateEmployeeModal,
    cityData
}) => {
    const [employeeObj, setEmployeeObj] = useState({})
    const [isReset, setIsReset] = useState(false)
    const {mix_background_layout} = useContext(CustomizerContext)

    const processData = tableData.map((element, index) => {
        let authorities = [... new Set(element.authorities.split(","))]
        let uniqueServiceCities = [... new Set(element.serviceCities.split(","))]
        let serviceCities = uniqueServiceCities.map((city, index) => {
            let findIndex = cityData.findIndex((c) => c.id == Number(city))
            if (findIndex >= 0) {
                return cityData[findIndex]["value"]["name"]
            }
        }).filter((c) => c != undefined || null || "")
        return {
            userId: element.userId ? element.userId : "-",
            fullName: element.fullName ? element.fullName : "-",
            email: element.email ? element.email : "-",
            mobile: element.mobile ? element.mobile : "-",
            activated: element.activated ? "true" : "false",
            authorities: authorities.length > 0
                ?
                <>
                    <span
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "initial",
                        }}
                    >
                        {authorities.join(" , ")}
                    </span>
                </>
                : "-",
            serviceCities: serviceCities.length > 0
                ?
                <>
                    <span
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "initial",
                        }}
                    >
                        {serviceCities.join(" , ")}
                    </span>
                </>
                : "-",
            action: <ActionOptions>
                <Fragment>
                    <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                            setEditId(element.id);
                            toggleCreateEmployeeModal();
                        }}
                    >
                        <i className="fa fa-pencil"></i> Edit
                    </DropdownItem>
                    <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                            setEmployeeObj(element);
                            setIsReset(true);
                        }}
                    >
                        <i className="fa fa-wrench"></i> Reset Password
                    </DropdownItem>
                </Fragment>
            </ActionOptions>
        };
    });
    return (
        <Fragment>
            <div className="table-responsive employee-table">
                <DataTable
                    columns={employeeColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
            <HardResetPassword
                Large={isReset}
                title={"Reset External user Password"}
                LargeModaltoggle={() => {
                    setEmployeeObj({})
                    setIsReset(!isReset)
                }}
                employeeObj={employeeObj}
            />

        </Fragment>
    );
};

export default ExternalUserTable;
